import { Link } from 'react-router-dom';
import { useProgress } from '../../hooks/useProgress';

const APStatsProgress = () => {
  const progressData = [
    {
      unitId: 'unit1',
      unitTitle: 'Unit 1: Exploring One-Variable Data',
      weight: '15%–23%',
      skills: [
        { id: 'frequency-tables', name: 'Constructing Frequency Tables', total: 30 },
        { id: 'bar-charts', name: 'Creating and Interpreting Bar Charts', total: 30 },
        { id: 'pie-charts', name: 'Creating and Interpreting Pie Charts', total: 30 },
        { id: 'dotplots', name: 'Creating and Interpreting Dotplots', total: 30 },
        { id: 'stemplots', name: 'Constructing Stemplots', total: 30 },
        { id: 'histograms', name: 'Creating and Interpreting Histograms', total: 30 },
        { id: 'distribution-shape', name: 'Describing Distribution Shape', total: 30 },
        { id: 'measures-center', name: 'Calculating Mean, Median, and Mode', total: 30 },
        { id: 'range-iqr', name: 'Calculating Range and IQR', total: 30 },
        { id: 'standard-deviation', name: 'Calculating Standard Deviation', total: 30 },
        { id: 'effects-transformations', name: 'Effects of Transformations', total: 30 },
        { id: 'boxplots', name: 'Creating and Interpreting Boxplots', total: 30 },
        { id: 'comparing-groups', name: 'Comparing Center and Spread', total: 30 }
      ]
    },
    {
      unitId: 'unit2',
      unitTitle: 'Unit 2: Exploring Two-Variable Data',
      weight: '5%–7%',
      skills: [
        { id: 'creating-scatterplots', name: 'Creating and Interpreting Scatterplots', total: 30 },
        { id: 'outliers-influential', name: 'Identifying Outliers and Influential Points', total: 30 },
        { id: 'correlation-coefficient', name: 'Calculating Correlation Coefficient', total: 30 },
        { id: 'properties-correlation', name: 'Properties of Correlation', total: 30 },
        { id: 'lsrl', name: 'Finding LSRL', total: 30 },
        { id: 'residuals', name: 'Calculating and Interpreting Residuals', total: 30 },
        { id: 'r-squared', name: 'Coefficient of Determination (r²)', total: 30 }
      ]
    },
    {
      unitId: 'unit3',
      unitTitle: 'Unit 3: Collecting Data',
      weight: '12%–15%',
      skills: [
        { id: 'simple-random-sample', name: 'Simple Random Sample (SRS)', total: 30 },
        { id: 'stratified-cluster', name: 'Stratified and Cluster Sampling', total: 30 },
        { id: 'sampling-bias', name: 'Sources of Bias in Sampling', total: 30 },
        { id: 'experimental-design', name: 'Basic Experimental Design Principles', total: 30 },
        { id: 'blocking-matching', name: 'Blocking and Matched Pairs', total: 30 },
        { id: 'confounding-lurking', name: 'Confounding and Lurking Variables', total: 30 }
      ]
    },
    {
      unitId: 'unit4',
      unitTitle: 'Unit 4: Probability & Distributions',
      weight: '10%–20%',
      skills: [
        { id: 'probability-rules', name: 'Basic Probability Rules', total: 30 },
        { id: 'conditional-probability', name: 'Conditional Probability', total: 30 },
        { id: 'independence', name: 'Independent vs Disjoint Events', total: 30 },
        { id: 'expected-value', name: 'Expected Value and Variance', total: 30 },
        { id: 'combining-variables', name: 'Combining Random Variables', total: 30 },
        { id: 'normal-distribution', name: 'Normal Distribution and z-scores', total: 30 },
        { id: 'binomial-distribution', name: 'Binomial Distribution', total: 30 },
        { id: 'geometric-distribution', name: 'Geometric Distribution', total: 30 }
      ]
    },
    {
      unitId: 'unit5',
      unitTitle: 'Unit 5: Sampling Distributions',
      weight: '7%–12%',
      skills: [
        { id: 'variability-concept', name: 'Understanding Sampling Variability', total: 30 },
        { id: 'proportion-sampling-dist', name: 'Sampling Distribution of p̂', total: 30 },
        { id: 'mean-sampling-dist', name: 'Sampling Distribution of x̄ and CLT', total: 30 }
      ]
    },
    {
      unitId: 'unit6',
      unitTitle: 'Unit 6: Inference for Proportions',
      weight: '12%–15%',
      skills: [
        { id: 'one-prop-ci', name: 'One-Sample CI for Proportion', total: 30 },
        { id: 'two-prop-ci', name: 'Two-Sample CI for Proportions', total: 30 },
        { id: 'one-prop-test', name: 'One-Sample z-Test for Proportion', total: 30 },
        { id: 'two-prop-test', name: 'Two-Sample z-Test for Proportions', total: 30 }
      ]
    },
    {
      unitId: 'unit7',
      unitTitle: 'Unit 7: Inference for Means',
      weight: '10%–18%',
      skills: [
        { id: 'one-mean-ci', name: 'One-Sample t-Interval for Mean', total: 30 },
        { id: 'two-mean-ci', name: 'Two-Sample t-Interval for Means', total: 30 },
        { id: 'paired-t-ci', name: 'Paired t-Interval', total: 30 },
        { id: 'one-mean-test', name: 'One-Sample t-Test for Mean', total: 30 },
        { id: 'two-mean-test', name: 'Two-Sample t-Test for Means', total: 30 },
        { id: 'paired-t-test', name: 'Paired t-Test', total: 30 }
      ]
    },
    {
      unitId: 'unit8',
      unitTitle: 'Unit 8: Chi-Square Tests',
      weight: '2%–5%',
      skills: [
        { id: 'chi-square-gof', name: 'Chi-Square Goodness-of-Fit Test', total: 30 },
        { id: 'chi-square-independence', name: 'Chi-Square Test for Independence', total: 30 },
        { id: 'chi-square-homogeneity', name: 'Chi-Square Test for Homogeneity', total: 30 }
      ]
    },
    {
      unitId: 'unit9',
      unitTitle: 'Unit 9: Inference for Slopes',
      weight: '2%–5%',
      skills: [
        { id: 'conditions-linear-regression', name: 'Conditions for Regression Inference', total: 30 },
        { id: 't-test-slope', name: 't-Test for Slope', total: 30 },
        { id: 'ci-slope', name: 'Confidence Interval for Slope', total: 30 },
        { id: 'slope-interpretation', name: 'Interpreting Computer Regression Output', total: 30 }
      ]
    }
  ];

  const { getSkillProgress, toggleQuestion, getUnitProgress, getOverallProgress } = useProgress('ap-stats');

  const overallProgress = getOverallProgress(progressData);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-pink-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-16">
        <div className="max-w-6xl mx-auto px-6">
          <Link 
            to="/ap-statistics" 
            className="inline-flex items-center text-purple-100 hover:text-white mb-6 transition-colors"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to AP Statistics Curriculum
          </Link>
          <h1 className="text-5xl font-bold mb-4">AP Statistics Progress Tracker</h1>
          <p className="text-xl text-purple-100 max-w-3xl">
            Track your mastery across all 9 units. Mark questions as completed to visualize your progress toward exam readiness.
          </p>
        </div>
      </div>

      {/* Overall Progress */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">Overall Progress</h2>
              <p className="text-gray-600 mt-1">{overallProgress.completed} of {overallProgress.total} questions completed</p>
            </div>
            <div className="text-right">
              <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                {overallProgress.percentage}%
              </div>
              <p className="text-gray-600 text-sm mt-1">Complete</p>
            </div>
          </div>
          
          <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-purple-600 to-pink-600 rounded-full transition-all duration-500"
              style={{ width: `${overallProgress.percentage}%` }}
            ></div>
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-green-50 rounded-lg p-6">
              <div className="flex items-center justify-between mb-2">
                <span className="text-green-700 font-semibold">Mastered</span>
                <i className="ri-checkbox-circle-fill text-green-600 text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-green-900">{overallProgress.completed}</div>
              <p className="text-sm text-green-700 mt-1">Questions completed</p>
            </div>

            <div className="bg-blue-50 rounded-lg p-6">
              <div className="flex items-center justify-between mb-2">
                <span className="text-blue-700 font-semibold">In Progress</span>
                <i className="ri-time-line text-blue-600 text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-blue-900">{overallProgress.total - overallProgress.completed}</div>
              <p className="text-sm text-blue-700 mt-1">Questions remaining</p>
            </div>

            <div className="bg-purple-50 rounded-lg p-6">
              <div className="flex items-center justify-between mb-2">
                <span className="text-purple-700 font-semibold">Total Skills</span>
                <i className="ri-book-2-line text-purple-600 text-2xl"></i>
              </div>
              <div className="text-3xl font-bold text-purple-900">{progressData.reduce((sum, unit) => sum + unit.skills.length, 0)}</div>
              <p className="text-sm text-purple-700 mt-1">Across 9 units</p>
            </div>
          </div>
        </div>

        {/* Unit Progress Cards */}
        <div className="space-y-6">
          {progressData.map((unit) => {
            const unitProgress = getUnitProgress(unit);
            return (
              <div key={unit.unitId} className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 px-8 py-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-2xl font-bold text-white">{unit.unitTitle}</h3>
                      <p className="text-purple-100 mt-1">Exam Weight: {unit.weight}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-3xl font-bold text-white">{unitProgress.percentage}%</div>
                      <p className="text-purple-100 text-sm">{unitProgress.completed}/{unitProgress.total} questions</p>
                    </div>
                  </div>
                  <div className="mt-4 w-full bg-purple-800 bg-opacity-30 rounded-full h-3">
                    <div 
                      className="h-full bg-white rounded-full transition-all duration-500"
                      style={{ width: `${unitProgress.percentage}%` }}
                    ></div>
                  </div>
                </div>

                <div className="p-8">
                  <div className="grid grid-cols-1 gap-4">
                    {unit.skills.map((skill) => {
                      const skillProgress = getSkillProgress(skill.id, skill.total);
                      const isComplete = skillProgress.percentage === 100;
                      
                      return (
                        <div key={skill.id} className="border border-gray-200 rounded-lg p-5 hover:border-purple-300 transition-colors">
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center space-x-3 flex-1">
                              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
                                isComplete ? 'bg-green-100' : 'bg-gray-100'
                              }`}>
                                <i className={`${
                                  isComplete ? 'ri-checkbox-circle-fill text-green-600' : 'ri-circle-line text-gray-400'
                                } text-xl`}></i>
                              </div>
                              <div className="flex-1 min-w-0">
                                <h4 className="font-semibold text-gray-900 truncate">{skill.name}</h4>
                                <p className="text-sm text-gray-600">{skillProgress.completed}/{skill.total} completed</p>
                              </div>
                            </div>
                            <div className="text-right ml-4">
                              <span className={`text-2xl font-bold ${
                                isComplete ? 'text-green-600' : 'text-purple-600'
                              }`}>
                                {skillProgress.percentage}%
                              </span>
                            </div>
                          </div>

                          <div className="w-full bg-gray-200 rounded-full h-2 mb-3">
                            <div 
                              className={`h-full rounded-full transition-all duration-300 ${
                                isComplete ? 'bg-green-500' : 'bg-gradient-to-r from-purple-600 to-pink-600'
                              }`}
                              style={{ width: `${skillProgress.percentage}%` }}
                            ></div>
                          </div>

                          {/* Question Checkboxes */}
                          <div className="flex flex-wrap gap-2">
                            {Array.from({ length: skill.total }, (_, i) => {
                              const questionId = `${skill.id}-q${i + 1}`;
                              const isChecked = skillProgress.completedQuestions.includes(questionId);
                              
                              return (
                                <button
                                  key={questionId}
                                  onClick={() => toggleQuestion(skill.id, questionId)}
                                  className={`w-8 h-8 rounded flex items-center justify-center text-xs font-semibold transition-all ${
                                    isChecked 
                                      ? 'bg-green-500 text-white hover:bg-green-600' 
                                      : 'bg-gray-100 text-gray-600 hover:bg-purple-100 hover:text-purple-700'
                                  }`}
                                  title={`Question ${i + 1}`}
                                >
                                  {i + 1}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Study Plan Link */}
        <div className="mt-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl p-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Need a Structured Study Plan?</h2>
          <p className="text-purple-100 mb-6 max-w-2xl mx-auto">
            Follow our 13-week study schedule with daily practice goals mapped to every unit and skill.
          </p>
          <Link 
            to="/ap-stats-study-plan" 
            className="inline-block bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-purple-50 transition-colors"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            View Study Plan
          </Link>
        </div>
      </div>
    </div>
  );
};

export default APStatsProgress;